"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ImageGallery;
var _react = _interopRequireWildcard(require("react"));
var _fslightboxReact = _interopRequireDefault(require("fslightbox-react"));
var _uniqid = _interopRequireDefault(require("uniqid"));
require("./ImageGallery.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ImageGallery(_ref) {
  let {
    imgArray,
    columnWidth = 230,
    gapSize = 24
  } = _ref;
  const [lightboxController, setLightboxController] = (0, _react.useState)({
    toggler: false,
    slide: 1
  });
  const imgElementArray = imgArray.map((item, index) => /*#__PURE__*/_react.default.createElement("figure", {
    className: "codesweetly-rigg-image-figure",
    style: {
      marginBottom: `${gapSize}px`
    },
    key: (0, _uniqid.default)()
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: item.alt,
    src: item.src,
    onClick: () => openLightboxOnSlide(index + 1)
  }), item.caption ? /*#__PURE__*/_react.default.createElement("figcaption", null, item.caption) : ""));
  function openLightboxOnSlide(number) {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "codesweetly-rigg-imgs-container",
    style: {
      columnWidth: `${columnWidth}px`,
      columnGap: `${gapSize}px`
    }
  }, imgElementArray, /*#__PURE__*/_react.default.createElement(_fslightboxReact.default, {
    toggler: lightboxController.toggler,
    slide: lightboxController.slide,
    sources: imgArray.map(item => item.src)
  }));
}